import Typography, { TypographyOptions } from 'typography';
import { blackGray, darkGray } from '../styles';

const theme: TypographyOptions = {
  baseFontSize: '14px',
  baseLineHeight: 1.6875,
  googleFonts: [
    {
      name: 'Quicksand',
      styles: ['500', '500i', '700'],
    },
    {
      name: 'Montserrat',
      styles: ['700'],
    },
  ],
  headerFontFamily: ['Montserrat', 'sans-serif'],
  bodyFontFamily: ['Quicksand', 'sans-serif'],
  headerColor: darkGray,
  bodyColor: blackGray,
  headerWeight: 700,
  bodyWeight: 500,
  boldWeight: 700,
  overrideStyles: ({ adjustFontSizeTo, scale, rhythm }, options) => ({
    'label,input,button': {
      letterSpacing: `${rhythm(1 / 20)}`,
    },
    a: {
      color: options.bodyColor,
      textDecoration: 'none',
      cursor: 'pointer',
      transition: 'color .3s',
    },
    h1: {
      fontSize: `${rhythm(1.25)}`,
      lineHeight: `${rhythm(1.75)}`,
    },
    'h1,h2,h3,h4,h5,h6': {
      transition: 'color .3s',
    },
    h5: {
      marginBottom: `${rhythm(0.5)}`,
    },
  }),
};

export const typography = new Typography(theme);

export const rhythm = typography.rhythm;

export default typography;
